import { FormGroup } from '@angular/forms';

export class FormService {
  constructor() {

  }
  markDirty(formGroup: FormGroup) {
    if (formGroup.controls) {
      const keys = Object.keys(formGroup.controls);
      for (let i = 0; i < keys.length; i++) {
        const control = formGroup.controls[keys[i]];
        control.markAsDirty();
        control.updateValueAndValidity({ onlySelf: false, emitEvent: true });
      }
    }
  }
}

